import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import NavbarFirstPage from '../../components/_dashboard/user/NavbarFirstPage';
import Footer from '../../components/_dashboard/user/Footer';
// ----------------------------------------------------------------------

export default function Layout() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <NavbarFirstPage />
      <Outlet />
      <Footer />
    </>
  );
}
